import React from 'react'
import Modal from './Modal'
import classes from './Cart.module.css'
import CartContext from '../store/CartContext'
import { useContext } from 'react'


const Cart = (props) => {


    const cartContext = useContext(CartContext);

    const onItemRemoveHandler = (id)=>{
        cartContext.removeItem(id);
    }

    const totalAmountBTC = cartContext.totalAmountBTC;
    const totalAmountETH = cartContext.totalAmountETH;

    const cartHasItems = cartContext.items.length>0;

    const itemsList = (
        <ul>
            {cartContext.items.map((item)=>{
                const image = require('./img/'+ item.image +'.png');
                return(
                    <li key={item.id}>
                            <div className={classes.cartItem}>
                                <div className={classes.itemLeft}><img src={image.default} alt="" /></div>
                                <div className={classes.itemCenter}>{item.name}</div>
                                <div className={classes.itemRight}>
                                    <p>x {item.amount}  <i className="fas fa-trash" onClick={onItemRemoveHandler.bind(null, item.id)}></i></p>
                                </div>

                            </div>
                    </li>
                    
                    )})
        
            }
                    
        </ul>
    );



    return (
        <Modal onHideModal={props.onHideModal}>
            <div className={classes.cartContainer}>
                <h2>Shopping Cart</h2> 
                <div className={classes.cartItems}>
                    
                    <div className={classes.itemsListContainer}>
                      {itemsList}  
                    </div>
                    

                    <div className={classes.cartBottom}>
                        <h3>TOTAL PRICE # <span>
                            {totalAmountBTC.toFixed(6)} BTC <br />
                             {totalAmountETH.toFixed(6)} ETH
                        </span>
                            </h3>
                        
                        {cartHasItems && <button className={classes.checkOut}>Check Out</button>}
                        <button className={classes.close} onClick={props.onHideModal}>Close</button>
                    </div>
                </div>
            </div>
        </Modal>
    )
}

export default Cart
